[
  {
    "name": "$braze_external_id",
    "displayName": "Braze User ID",
    "description": "The external ID of the user in Braze. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$iterable_user_id",
    "displayName": "Iterable User ID",
    "description": "The external ID of the user in Iterable. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$moengage_user_id",
    "displayName": "MoEngage User ID",
    "description": "The external ID of the user in MoEngage. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$leanplum_user_id",
    "displayName": "Leanplum User ID",
    "description": "The external ID of the user in Leanplum. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$onesignal_user_id",
    "displayName": "OneSignal User ID",
    "description": "The external ID of the user in OneSignal. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$kameleoon_mapping_id",
    "displayName": "Kameleoon User ID",
    "description": "The external ID of the user in Kameleoon. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$vwo_user_id",
    "displayName": "VWO User ID",
    "description": "The external ID of the user in VWO. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$airship_named_user",
    "displayName": "Airship Named User",
    "description": "Named User in Airship. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$ios_urban_airship_channel_id",
    "displayName": "iOS Urban Airship Channel ID",
    "description": "Airship Channel ID for iOS Users. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$android_urban_airship_channel_id",
    "displayName": "Android Urban Airship Channel ID",
    "description": "Airship Channel ID for Android Users. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$xtremepush_user_id",
    "displayName": "Xtremepush User ID",
    "description": "The external ID of the user in Xtremepush. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$apptimize_user_id",
    "displayName": "Apptimize User ID",
    "description": "The external ID of the user in Apptimize. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$CleverTap_user_id",
    "displayName": "CleverTap User ID",
    "description": "The external ID of the user in CleverTap. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$pushwoosh_user_id",
    "displayName": "Pushwoosh User ID",
    "description": "The external ID of the user in Pushwoosh. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$abtasty_user_id",
    "displayName": "ABTasty User ID",
    "description": "The external ID of the user in VWO. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  },
  {
    "name": "$flagship_user_id",
    "displayName": "Flagship User ID",
    "description": "The external ID of the user in Flagship. Used for cross-platform user identification.",
    "type": "string",
    "hidden": true
  }
]
